console.log('[Warranty] cart.js v5 loaded');

class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();

      const cartItems =
        this.closest('cart-items') ||
        this.closest('cart-drawer-items');

      if (cartItems) {
        cartItems.updateQuantity(this.dataset.index, 0);
      }
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);


class CartItems extends HTMLElement {
  constructor() {
    super();

    this.lineItemStatusElement =
      document.getElementById('shopping-cart-line-item-status') ||
      document.getElementById('CartDrawer-LineItemStatus');

    const debouncedOnChange = debounce((event) => {
      // The Lifetime Warranty toggle is handled by the document-level
      // listener at the bottom of this file, so it is ignored here
      // to stop the warranty being added twice.
      if (event.target.matches('.cart-upsell-toggle')) {
        return;
      }

      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(
      PUB_SUB_EVENTS.cartUpdate,
      (event) => {
        if (event.source === 'cart-items') {
          return;
        }

        this.onCartUpdate();
      }
    );

    if (this.tagName !== 'CART-DRAWER-ITEMS') {
      fetch(`${routes.cart_url}.js`)
        .then((response) => response.json())
        .then((parsedState) => {
          this.updateCartUpsellToggleState(parsedState);
          this.updateCartUpsellVisibility(parsedState.item_count);
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  onChange(event) {
    this.updateQuantity(
      event.target.dataset.index,
      event.target.value,
      document.activeElement
        ? document.activeElement.getAttribute('name')
        : null,
      event.target.dataset.quantityVariantId
    );
  }

  onCartUpdate() {
    if (this.tagName === 'CART-DRAWER-ITEMS') {
      return fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(
            responseText,
            'text/html'
          );

          const selectors = ['cart-drawer-items', '.cart-drawer__footer'];

          for (const selector of selectors) {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);

            if (targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);
            }
          }

          const parsedStateElement = html.querySelector(
            '[data-cart-drawer-state]'
          );

          const parsedState = parsedStateElement
            ? JSON.parse(parsedStateElement.textContent)
            : null;

          this.updateCartUpsellToggleState();

          if (parsedState) {
            this.updateCartUpsellVisibility(parsedState.item_count);
          }
        })
        .catch((e) => {
          console.error(e);
        });
    }

    return fetch(`${routes.cart_url}?section_id=main-cart-items`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(
          responseText,
          'text/html'
        );

        const sourceQty = html.querySelector('cart-items');

        if (sourceQty) {
          this.innerHTML = sourceQty.innerHTML;
        }

        const parsedStateElement = html.querySelector('[data-cart-state]');

        const parsedState = parsedStateElement
          ? JSON.parse(parsedStateElement.textContent)
          : null;

        this.updateCartUpsellToggleState();

        if (parsedState) {
          this.updateCartUpsellVisibility(parsedState.item_count);
        }
      })
      .catch((e) => {
        console.error(e);
      });
  }

  getCartUpsellVariantId() {
    const toggle = document.getElementById('cart-upsell-toggle');

    if (toggle && toggle.dataset.cartUpsellVariantId) {
      return toggle.dataset.cartUpsellVariantId;
    }

    const container = document.querySelector(
      '.cart-upsell-toggle-container[data-cart-upsell-variant-id]'
    );

    if (container && container.dataset.cartUpsellVariantId) {
      return container.dataset.cartUpsellVariantId;
    }

    const scriptTag = document.querySelector(
      'script[data-cart-upsell-variant-id]'
    );

    if (scriptTag && scriptTag.dataset.cartUpsellVariantId) {
      return scriptTag.dataset.cartUpsellVariantId;
    }

    return '';
  }

  async getCartState() {
    const response = await fetch(`${routes.cart_url}.js`);
    return response.json();
  }

  findUpsellLine(cartState, cartUpsellVariantId) {
    if (!cartState || !Array.isArray(cartState.items)) {
      return 0;
    }

    const index = cartState.items.findIndex(
      (item) => String(item.variant_id) === String(cartUpsellVariantId)
    );

    return index === -1 ? 0 : index + 1;
  }

  updateCartUpsellToggleState(cartState) {
    const cartUpsellToggle = document.getElementById('cart-upsell-toggle');
    const cartUpsellVariantId = this.getCartUpsellVariantId();

    if (!cartUpsellToggle || !cartUpsellVariantId) {
      return;
    }

    if (cartUpsellToggle.dataset.busy === 'true') {
      return;
    }

    if (cartState && Array.isArray(cartState.items)) {
      cartUpsellToggle.checked =
        this.findUpsellLine(cartState, cartUpsellVariantId) > 0;
      return;
    }

    this.getCartState()
      .then((state) => {
        const currentToggle = document.getElementById('cart-upsell-toggle');

        if (currentToggle && currentToggle.dataset.busy !== 'true') {
          currentToggle.checked =
            this.findUpsellLine(state, cartUpsellVariantId) > 0;
        }
      })
      .catch((error) => {
        console.error('Could not check Lifetime Warranty state:', error);
      });
  }

  updateCartUpsellVisibility(itemCount) {
    const cartUpsellContainer = document.querySelector(
      '.cart-upsell-toggle-container'
    );

    if (!cartUpsellContainer) {
      return;
    }

    if (itemCount === 0) {
      cartUpsellContainer.classList.add('hidden');
    } else {
      cartUpsellContainer.classList.remove('hidden');
    }
  }

  onCartUpsellToggle(event) {
    const toggle = event.target;

    if (toggle.dataset.busy === 'true') {
      return;
    }

    const cartUpsellVariantId = this.getCartUpsellVariantId();

    if (!cartUpsellVariantId) {
      console.error('Lifetime Warranty variant ID is missing.');
      toggle.checked = false;

      const missingIdBox =
        document.getElementById('CartDrawer-CartErrors') ||
        document.getElementById('cart-errors');

      if (missingIdBox) {
        missingIdBox.textContent =
          'Warranty error: warranty product not found in theme settings.';
      }

      return;
    }

    const isChecked = toggle.checked;

    toggle.dataset.busy = 'true';
    toggle.disabled = true;

    const action = isChecked
      ? this.addUpsellProduct(cartUpsellVariantId)
      : this.removeUpsellProduct(cartUpsellVariantId);

    action
      .catch((error) => {
        console.error(
          isChecked
            ? 'Could not add Lifetime Warranty:'
            : 'Could not remove Lifetime Warranty:',
          error
        );

        toggle.checked = !isChecked;

        const errorBox =
          document.getElementById('CartDrawer-CartErrors') ||
          document.getElementById('cart-errors');

        if (errorBox) {
          errorBox.textContent =
            'Warranty error: ' + (error && error.message ? error.message : error);
        }
      })
      .finally(() => {
        const currentToggle =
          document.getElementById('cart-upsell-toggle') || toggle;

        currentToggle.dataset.busy = 'false';
        currentToggle.disabled = false;

        this.updateCartUpsellToggleState();
      });
  }

  async addUpsellProduct(cartUpsellVariantId) {
    // Do not add a second warranty if one is already in the cart
    const currentState = await this.getCartState();

    if (this.findUpsellLine(currentState, cartUpsellVariantId) > 0) {
      await this.refreshCartTotals();
      return;
    }

    const sectionIds = this.getSectionsToRender().map(
      (section) => section.section
    );

    const response = await fetch(`${routes.cart_add_url}.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        items: [
          {
            id: Number(cartUpsellVariantId),
            quantity: Math.max(1, countWarrantyEligibleItems(currentState, cartUpsellVariantId))
          }
        ],
        sections: sectionIds,
        sections_url: window.location.pathname
      })
    });

    if (!response.ok) {
      const errorText = await response.text();
      console.error('Failed to add Lifetime Warranty:', errorText);

      let reason = errorText;

      try {
        const parsedError = JSON.parse(errorText);
        reason = parsedError.description || parsedError.message || errorText;
      } catch (e) {}

      throw new Error(reason);
    }

    const addedItem = await response.json();

    if (addedItem.sections) {
      this.renderCartSections(addedItem.sections);
    }

    if (!addedItem.sections || this.tagName === 'CART-DRAWER-ITEMS') {
      await this.onCartUpdate();
    }

    await this.refreshCartTotals();
  }

  async removeUpsellProduct(cartUpsellVariantId) {
    const cartState = await this.getCartState();
    const line = this.findUpsellLine(cartState, cartUpsellVariantId);

    if (!line) {
      await this.refreshCartTotals();
      return;
    }

    await this.updateQuantity(line, 0, null, cartUpsellVariantId);
  }

  renderCartSections(sections) {
    if (!sections) {
      return;
    }

    this.getSectionsToRender().forEach((section) => {
      const sectionElement = document.getElementById(section.id);

      if (!sectionElement || !sections[section.section]) {
        return;
      }

      const elementToReplace =
        sectionElement.querySelector(section.selector) || sectionElement;

      elementToReplace.innerHTML = this.getSectionInnerHTML(
        sections[section.section],
        section.selector
      );
    });
  }

  async refreshCartTotals() {
    try {
      const response = await fetch(`${routes.cart_url}.js`);
      const parsedState = await response.json();

      this.classList.toggle('is-empty', parsedState.item_count === 0);

      this.updateProgressBar({
        total_price: parsedState.total_price,
        items_subtotal_price: parsedState.items_subtotal_price
      });

      this.updateCartUpsellToggleState(parsedState);
      this.updateCartUpsellVisibility(parsedState.item_count);

      publish(PUB_SUB_EVENTS.cartUpdate, {
        source: 'cart-items',
        cartData: parsedState,
        variantId: undefined
      });
    } catch (error) {
      console.error('Could not refresh cart state:', error);
    }
  }

  getSectionsToRender() {
    const mainCartItems = document.getElementById('main-cart-items');
    const mainCartFooter = document.getElementById('main-cart-footer');

    return [
      {
        id: 'main-cart-items',
        section: mainCartItems ? mainCartItems.dataset.id : '',
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      },
      {
        id: 'main-cart-footer',
        section: mainCartFooter ? mainCartFooter.dataset.id : '',
        selector: '.js-contents',
      },
    ].filter((section) => section.section);
  }

  updateQuantity(line, quantity, name, variantId) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    return fetch(routes.cart_change_url, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);

        const quantityElement =
          document.getElementById(`Quantity-${line}`) ||
          document.getElementById(`Drawer-quantity-${line}`);

        const items = document.querySelectorAll('.cart-item');

        if (parsedState.errors) {
          if (quantityElement) {
            quantityElement.value = quantityElement.getAttribute('value');
          }

          this.updateLiveRegions(line, parsedState.errors);
          return;
        }

        this.classList.toggle('is-empty', parsedState.item_count === 0);

        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) {
          cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        }

        if (cartDrawerWrapper) {
          cartDrawerWrapper.classList.toggle(
            'is-empty',
            parsedState.item_count === 0
          );
        }

        this.getSectionsToRender().forEach((section) => {
          const sectionElement = document.getElementById(section.id);

          if (!sectionElement) {
            return;
          }

          const elementToReplace =
            sectionElement.querySelector(section.selector) || sectionElement;

          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
        });

        const updatedValue = parsedState.items[line - 1]
          ? parsedState.items[line - 1].quantity
          : undefined;

        let message = '';

        if (
          items.length === parsedState.items.length &&
          quantityElement &&
          updatedValue !== parseInt(quantityElement.value)
        ) {
          if (typeof updatedValue === 'undefined') {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace(
              '[quantity]',
              updatedValue
            );
          }
        }

        this.updateLiveRegions(line, message);

        const lineItem =
          document.getElementById(`CartItem-${line}`) ||
          document.getElementById(`CartDrawer-Item-${line}`);

        if (lineItem && name && lineItem.querySelector(`[name="${name}"]`)) {
          const drawer = document.querySelector('cart-drawer');

          drawer
            ? trapFocus(drawer, lineItem.querySelector(`[name="${name}"]`))
            : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (
          parsedState.item_count === 0 &&
          document.querySelector('cart-drawer')
        ) {
          trapFocus(
            document
              .querySelector('cart-drawer')
              .querySelector('.drawer__inner-empty'),
            document.querySelector('cart-drawer').querySelector('a')
          );
        } else if (
          document.querySelector('.cart-item') &&
          document.querySelector('cart-drawer')
        ) {
          trapFocus(
            document.querySelector('cart-drawer'),
            document.querySelector('.cart-item__name')
          );
        }

        this.updateProgressBar({
          total_price: parsedState.total_price,
          items_subtotal_price: parsedState.items_subtotal_price
        });

        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'cart-items',
          cartData: parsedState,
          variantId: variantId
        });

        this.updateCartUpsellToggleState(parsedState);
        this.updateCartUpsellVisibility(parsedState.item_count);
      })
      .catch((error) => {
        console.error('Cart update error:', error);

        this.querySelectorAll('.loading__spinner').forEach((overlay) =>
          overlay.classList.add('hidden')
        );

        const errors =
          document.getElementById('cart-errors') ||
          document.getElementById('CartDrawer-CartErrors');

        if (errors) {
          errors.textContent = window.cartStrings.error;
        }
      })
      .finally(() => {
        this.disableLoading(line);
      });
  }

  updateProgressBar({ total_price, items_subtotal_price }) {
    const progressWrapper = document.getElementById('cart-progress-wrapper');

    if (!progressWrapper) {
      return;
    }

    const cartTotalCents =
      progressWrapper.dataset.useItemsSubtotal === 'true'
        ? items_subtotal_price
        : total_price;

    const currencyFormat = progressWrapper.dataset.currencyFormat;
    const thresholds = progressWrapper.dataset.thresholds.split(',').map(Number);
    const preGoalMessages = progressWrapper.dataset.preGoalMessages.split('||');
    const postGoalMessages = progressWrapper.dataset.postGoalMessages.split('||');

    const totalThreshold = thresholds[thresholds.length - 1];

    const progressPercentage = Math.min(
      (cartTotalCents / totalThreshold) * 100,
      100
    );

    const progressBar = document.getElementById('cart-progress-bar');
    const goalIcons = document.querySelectorAll('.goal-icon');
    const goalMessageElement = document.querySelector('.goal-message');

    if (!progressBar || !goalMessageElement) {
      return;
    }

    if (cartTotalCents === 0) {
      progressWrapper.style.display = 'none';
      goalMessageElement.style.display = 'none';
      progressBar.style.width = '0%';
      return;
    }

    progressWrapper.style.display = 'block';
    progressBar.style.width = `${progressPercentage}%`;

    if (progressPercentage >= 100) {
      progressWrapper.classList.add('full');
    } else {
      progressWrapper.classList.remove('full');
    }

    let nextGoalIndex = -1;

    for (let i = 0; i < thresholds.length; i++) {
      if (cartTotalCents < thresholds[i]) {
        nextGoalIndex = i;
        break;
      }
    }

    goalIcons.forEach((goalIcon, index) => {
      const cartTotalDiff = cartTotalCents - thresholds[index];
      const icon = goalIcon.querySelector('img');
      const goalNumber = goalIcon.dataset.index;

      if (!icon) {
        return;
      }

      if (cartTotalDiff < 0) {
        const regularIconUrl = goalIcon.dataset.regularIcon;

        if (regularIconUrl) {
          icon.src = regularIconUrl;
          icon.srcset = `${regularIconUrl} 50w`;
          icon.alt = `Goal ${goalNumber}`;
        }
      } else {
        const reachedIconUrl = goalIcon.dataset.reachedIcon;

        if (reachedIconUrl) {
          icon.src = reachedIconUrl;
          icon.srcset = `${reachedIconUrl} 50w`;
          icon.alt = `Goal ${goalNumber} Reached`;
        }
      }
    });

    goalMessageElement.style.display = 'block';

    if (nextGoalIndex === -1) {
      goalMessageElement.innerHTML =
        postGoalMessages[postGoalMessages.length - 1];
    } else {
      const remainingAmount = (thresholds[nextGoalIndex] - cartTotalCents) / 100;

      const remainingAmountFormatted = this.formatCurrency(
        currencyFormat,
        remainingAmount
      );

      goalMessageElement.innerHTML = preGoalMessages[nextGoalIndex].replace(
        '[x]',
        remainingAmountFormatted
      );
    }
  }

  formatCurrency(currencyFormat, amount) {
    return currencyFormat
      .replace('{{amount}}', amount.toFixed(2))
      .replace('{{amount_no_decimals}}', amount.toFixed(0))
      .replace(
        '{{amount_with_comma_separator}}',
        amount.toFixed(2).replace('.', ',')
      )
      .replace(
        '{{amount_no_decimals_with_comma_separator}}',
        amount.toFixed(0).replace('.', ',')
      )
      .replace(
        '{{amount_with_apostrophe_separator}}',
        amount.toFixed(2).replace('.', "'")
      )
      .replace(
        '{{amount_no_decimals_with_space_separator}}',
        amount.toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
      )
      .replace(
        '{{amount_with_space_separator}}',
        amount.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
      )
      .replace(
        '{{amount_with_period_and_space_separator}}',
        amount.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
      );
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) ||
      document.getElementById(`CartDrawer-LineItemError-${line}`);

    if (lineItemError) {
      const errorText = lineItemError.querySelector('.cart-item__error-text');

      if (errorText) {
        errorText.innerHTML = message;
      }
    }

    if (this.lineItemStatusElement) {
      this.lineItemStatusElement.setAttribute('aria-hidden', true);
    }

    const cartStatus =
      document.getElementById('cart-live-region-text') ||
      document.getElementById('CartDrawer-LiveRegionText');

    if (!cartStatus) {
      return;
    }

    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    if (!html) {
      return '';
    }

    const parsed = new DOMParser().parseFromString(html, 'text/html');
    const element = parsed.querySelector(selector);

    return element ? element.innerHTML : '';
  }

  enableLoading(line) {
    const mainCartItems =
      document.getElementById('main-cart-items') ||
      document.getElementById('CartDrawer-CartItems');

    if (mainCartItems) {
      mainCartItems.classList.add('cart__items--disabled');
    }

    const cartItemElements = this.querySelectorAll(
      `#CartItem-${line} .loading__spinner`
    );

    const cartDrawerItemElements = this.querySelectorAll(
      `#CartDrawer-Item-${line} .loading__spinner`
    );

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) =>
      overlay.classList.remove('hidden')
    );

    if (document.activeElement && document.activeElement.blur) {
      document.activeElement.blur();
    }

    if (this.lineItemStatusElement) {
      this.lineItemStatusElement.setAttribute('aria-hidden', false);
    }
  }

  disableLoading(line) {
    const mainCartItems =
      document.getElementById('main-cart-items') ||
      document.getElementById('CartDrawer-CartItems');

    if (mainCartItems) {
      mainCartItems.classList.remove('cart__items--disabled');
    }

    const cartItemElements = this.querySelectorAll(
      `#CartItem-${line} .loading__spinner`
    );

    const cartDrawerItemElements = this.querySelectorAll(
      `#CartDrawer-Item-${line} .loading__spinner`
    );

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) =>
      overlay.classList.add('hidden')
    );
  }
}

customElements.define('cart-items', CartItems);


/*
 * Lifetime Warranty toggle
 * Delegated from the document so it keeps working even when
 * Shopify replaces the cart HTML. This is the only place the
 * toggle is handled, so the warranty is only ever added once.
 */
/*
 * Lifetime Warranty: one warranty per product
 * Whenever the cart changes, the warranty quantity is set to match
 * the number of products in the cart. If the customer has switched
 * the warranty off, nothing is added.
 */
function getWarrantyVariantId() {
  const toggle = document.getElementById('cart-upsell-toggle');

  if (toggle && toggle.dataset.cartUpsellVariantId) {
    return toggle.dataset.cartUpsellVariantId;
  }

  const container = document.querySelector(
    '.cart-upsell-toggle-container[data-cart-upsell-variant-id]'
  );

  if (container && container.dataset.cartUpsellVariantId) {
    return container.dataset.cartUpsellVariantId;
  }

  const scriptTag = document.querySelector('script[data-cart-upsell-variant-id]');

  return scriptTag ? scriptTag.dataset.cartUpsellVariantId || '' : '';
}

function countWarrantyEligibleItems(cartState, warrantyVariantId) {
  if (!cartState || !Array.isArray(cartState.items)) {
    return 0;
  }

  return cartState.items.reduce((total, item) => {
    if (String(item.variant_id) === String(warrantyVariantId)) {
      return total;
    }

    return total + item.quantity;
  }, 0);
}

let warrantySyncRunning = false;
let warrantySyncQueued = false;

async function syncWarrantyQuantity() {
  if (warrantySyncRunning) {
    warrantySyncQueued = true;
    return;
  }

  const warrantyVariantId = getWarrantyVariantId();

  if (!warrantyVariantId) {
    return;
  }

  const toggle = document.getElementById('cart-upsell-toggle');

  if (toggle && toggle.dataset.busy === 'true') {
    return;
  }

  warrantySyncRunning = true;

  try {
    const cartResponse = await fetch(`${routes.cart_url}.js`);
    const cartState = await cartResponse.json();

    const warrantyItem = cartState.items.find(
      (item) => String(item.variant_id) === String(warrantyVariantId)
    );

    // Warranty is switched off, so there is nothing to sync
    if (!warrantyItem) {
      return;
    }

    const targetQuantity = countWarrantyEligibleItems(cartState, warrantyVariantId);

    if (warrantyItem.quantity === targetQuantity) {
      return;
    }

    const cartItems =
      document.querySelector('cart-items') ||
      document.querySelector('cart-drawer-items');

    const sections =
      cartItems && typeof cartItems.getSectionsToRender === 'function'
        ? cartItems.getSectionsToRender().map((section) => section.section)
        : [];

    const changeResponse = await fetch(`${routes.cart_change_url}.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        id: warrantyItem.key,
        quantity: targetQuantity,
        sections: sections,
        sections_url: window.location.pathname
      })
    });

    if (!changeResponse.ok) {
      console.error('Could not update warranty quantity:', await changeResponse.text());
      return;
    }

    const updatedState = await changeResponse.json();

    const currentCartItems =
      document.querySelector('cart-items') ||
      document.querySelector('cart-drawer-items');

    if (currentCartItems) {
      if (updatedState.sections) {
        currentCartItems.renderCartSections(updatedState.sections);
      }

      if (currentCartItems.tagName === 'CART-DRAWER-ITEMS') {
        await currentCartItems.onCartUpdate();
      }

      currentCartItems.updateProgressBar({
        total_price: updatedState.total_price,
        items_subtotal_price: updatedState.items_subtotal_price
      });

      currentCartItems.updateCartUpsellToggleState(updatedState);
      currentCartItems.updateCartUpsellVisibility(updatedState.item_count);
    }
  } catch (error) {
    console.error('Warranty sync error:', error);
  } finally {
    warrantySyncRunning = false;

    if (warrantySyncQueued) {
      warrantySyncQueued = false;
      syncWarrantyQuantity();
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
      syncWarrantyQuantity();
    });
  }

  syncWarrantyQuantity();
});


document.addEventListener('change', (event) => {
  if (!event.target.matches('#cart-upsell-toggle')) {
    return;
  }

  const cartItems =
    document.querySelector('cart-items') ||
    document.querySelector('cart-drawer-items');

  if (!cartItems) {
    console.error('Cart items element not found.');
    event.target.checked = false;
    return;
  }

  cartItems.onCartUpsellToggle(event);
});


if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          'change',
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });

            fetch(routes.cart_update_url, { ...fetchConfig(), ...{ body } });
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}


const cartUpdatedEvent = new CustomEvent('cartUpdated', {
  detail: {
    message: 'Cart was updated',
  },
});

document.dispatchEvent(cartUpdatedEvent);